(function() {
  var host = window.location.hostname;
  var configs = {
    'papilora.gr': {
      text: '\u03A6\u0398\u0399\u039D\u039F\u03A0\u03A9\u03A1\u039F \u03A3\u03A4\u039F \u03A3\u03A0\u0399\u03A4\u0399 \u2014 \u03BD\u03AD\u03BF\u03B9 \u03B6\u03B5\u03C3\u03C4\u03BF\u03AF \u03C4\u03CC\u03BD\u03BF\u03B9',
      discount: '',
      linkText: '\u0394\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AE \u203a',
      linkUrl: '/collections/fthinoporinoi-pinakes'
    ,
      guarantee: '100 ημέρες για επιστροφή'
    },
    'www.papilora.gr': {
      text: '\u03A6\u0398\u0399\u039D\u039F\u03A0\u03A9\u03A1\u039F \u03A3\u03A4\u039F \u03A3\u03A0\u0399\u03A4\u0399 \u2014 \u03BD\u03AD\u03BF\u03B9 \u03B6\u03B5\u03C3\u03C4\u03BF\u03AF \u03C4\u03CC\u03BD\u03BF\u03B9',
      discount: '',
      linkText: '\u0394\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AE \u203a',
      linkUrl: '/collections/fthinoporinoi-pinakes'
    ,
      guarantee: '100 ημέρες για επιστροφή'
    },
    'papilora.hr': {
      text: 'JESEN U DOMU \u2014 novi topli tonovi na zidu',
      discount: '',
      linkText: 'Pogledaj kolekciju \u203a',
      linkUrl: '/collections/jesenske-slike'
    ,
      guarantee: '100 dana za povrat'
    },
    'www.papilora.hr': {
      text: 'JESEN U DOMU \u2014 novi topli tonovi na zidu',
      discount: '',
      linkText: 'Pogledaj kolekciju \u203a',
      linkUrl: '/collections/jesenske-slike'
    ,
      guarantee: '100 dana za povrat'
    },
    'papilora.si': {
      text: 'JESEN DOMA \u2014 novi topli toni na steni',
      discount: '',
      linkText: 'Poglej kolekcijo \u203a',
      linkUrl: '/collections/jesenske-slike-na-platnu'
    ,
      guarantee: '100 dni za vračilo'
    },
    'www.papilora.si': {
      text: 'JESEN DOMA \u2014 novi topli toni na steni',
      discount: '',
      linkText: 'Poglej kolekcijo \u203a',
      linkUrl: '/collections/jesenske-slike-na-platnu'
    ,
      guarantee: '100 dni za vračilo'
    },
    'papilora.it': {
      text: 'AUTUNNO IN CASA \u2014 nuovi toni caldi alla parete',
      discount: '',
      linkText: 'Scopri la collezione \u203a',
      linkUrl: '/collections/quadri-autunno'
    ,
      guarantee: '100 giorni per il reso'
    },
    'www.papilora.it': {
      text: 'AUTUNNO IN CASA \u2014 nuovi toni caldi alla parete',
      discount: '',
      linkText: 'Scopri la collezione \u203a',
      linkUrl: '/collections/quadri-autunno'
    ,
      guarantee: '100 giorni per il reso'
    },
  };
  var config = configs[host];
  if (!config) { return; }

  function insertBar() {
    if (document.getElementById('market-promo-bar')) { return; }

    var bar = document.createElement('div');
    bar.id = 'market-promo-bar';
    bar.style.cssText = 'background-color:#f5c518;padding:8px 40px 8px 10px;text-align:center;position:relative;font-family:Poppins,Arial,sans-serif;z-index:9999;';

    var html = '<span style="color:#333;font-size:14px;font-weight:500;letter-spacing:0.5px;">';
    html += config.text;
    if (config.discount) {
      html += ' <b style="color:#ffffff;font-size:16px;background-color:#401b60;padding:2px 8px;border-radius:4px;">';
      html += config.discount;
      html += '</b> ';
    } else { html += ' '; }
    html += '<a href="' + config.linkUrl + '" style="color:#401b60;font-weight:700;text-decoration:underline;text-underline-offset:3px;">';
    html += config.linkText;
    html += '</a>';
    if (config.guarantee) {
      html += ' <a href="' + config.linkUrl + '" style="background:#27AE60;color:#ffffff;padding:3px 11px;border-radius:999px;font-weight:700;text-decoration:none;white-space:nowrap;display:inline-block;margin-left:8px;">' + config.guarantee + ' \u203a</a>';
    }
    html += '</span>';
    html += '<button onclick="this.parentElement.remove()" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);background:none;border:none;font-size:20px;cursor:pointer;color:#333;padding:5px;line-height:1;" aria-label="Close">×</button>';
    bar.innerHTML = html;

    document.body.insertBefore(bar, document.body.firstChild);
  }

  function fixCustomerService() {
    var csTexts = {
      'papilora.si': 'Podpora strankam <a href="mailto:info@papilora.si"><strong>info@papilora.si</strong></a> | Klicni center (EU): <a href="tel:+421572225040"><strong>+421 57 222 5040</strong></a>',
      'papilora.it': 'Assistenza clienti <a href="mailto:info@papilora.it"><strong>info@papilora.it</strong></a> | Call center (EU): <a href="tel:+421572225040"><strong>+421 57 222 5040</strong></a>',
      'papilora.hr': 'Korisnička podrška <a href="mailto:info@papilora.hr"><strong>info@papilora.hr</strong></a> | Pozivni centar (EU): <a href="tel:+421572225040"><strong>+421 57 222 5040</strong></a>',
      'papilora.gr': 'Υποστήριξη πελατών <a href="mailto:info@papilora.gr"><strong>info@papilora.gr</strong></a> | Τηλεφωνικό κέντρο (EU): <a href="tel:+421572225040"><strong>+421 57 222 5040</strong></a>'
    };
    var baseHost = host.replace('www.', '');
    var csText = csTexts[baseHost];
    if (!csText) { return; }
    var el = document.querySelector('.customer-service-text');
    if (el) { el.innerHTML = '<p>' + csText + '</p>'; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { insertBar(); fixCustomerService(); });
  } else {
    insertBar();
    fixCustomerService();
  }
})();
